// extracted by mini-css-extract-plugin
module.exports = {"img":"Aside_img__2HVc3","linkText":"Aside_linkText__2f_5V"};